<template>
  <div class="cpt-role-avatar" :class="`${size} ${shape}`">
    <div class="avatar-img-background" :class="{'gradient': gradient}">
      <ChatImg
        v-if="img"
        :src="img"
        :lazy="!no_lazy"
        :animation="!no_lazy"
        :webp_quality="30"
        :thumbnail="thumbnail"
      />
      <i
        v-else
        class="iconfont"
        :class="icon"
        :style="{
          'color': color,
          'background-image': gradient_color
        }"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      default: '',
      type: String
    },
    hideOnline: {
      default: false,
    },
    size: {
      default: 'normal'
    },
    shape: {
      default: 'rectangle',
      type: String,
    },
    color: {
      type: [String, Number],
      default: 'unset',
    },
    gradient: {
      type: Boolean,
      default: false,
    },
    icon: {
      default: 'icon-admin',
      type: String
    },
    no_lazy: {
      default: false,
    },
  },
  computed: {
    gradient_color() {
      if (!this.gradient) return ''
      const color_arr = this.color.split(',')
      return `linear-gradient(90deg, ${color_arr[0]} 0%, ${color_arr[1]} 100%)`
    },
    thumbnail () {
      let size = 15
      if (this.size === 'normal') {
        size = 16
      } else if (this.size === 'middle') {
        size = 18
      } else if (this.size === 'pre-big') {
        size = 22
      } else if (this.size === 'big') {
        size = 24
      }
      return `${size * 3}x`
    }
  }
};
</script>

<style lang="scss">
.cpt-role-avatar {
  position: relative;
  display: flex;
  &.normal {
    width: 16px;
    height: 16px;
    i {
      font-size: 16px;
    }
  }
  &.x-small{
    width: 14px;
    height: 14px;
    i {
      font-size: 14px;
    }
  }
  &.small {
    width: 15px;
    height: 15px;
    i {
      font-size: 15px;
    }
  }
  &.middle {
    width: 18px;
    height: 18px;
    i {
      font-size: 18px;
    }
  }
  &.pre-big {
    width: 22px;
    height: 22px;
    i {
      font-size: 22px;
    }
  }
  &.big {
    width: 24px;
    height: 24px;
    i {
      font-size: 24px;
    }
  }
  &.rectangle {
    .avatar-img-background {
      border-radius: 3px;
      img {
        border-radius: 3px;
      }
    }
  }
  .avatar-img-background {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &.gradient {
      display: flex;
      i {
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        display: inline-block;
      }
    }
    .cpt-chat-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      margin-right: 0;
    }
    i {
      color: $d-op-6;
    }
  }
}
</style>
